import * as React from "react";
import {
  Avatar,
  Box,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";

import SellIcon from "@mui/icons-material/Sell";
import { SearchListItemLink } from "./SearchListItemLink";
import { priceFormat } from "src/common/UtilFunctions";

export const ProductListItem = (props: any) => {
  const { data, onClick } = props;
  const { content } = data;

  if (!content) {
    return null;
  }

  return (
    <ListItem
      component={SearchListItemLink}
      data={data}
      onClick={onClick}
      alignItems="flex-start"
      sx={{
        textDecoration: "none",
        "&:hover": {
          textDecoration: "none",
        },
        "& a": {
          textDecoration: "none",
        },
        "& a:hover": {
          textDecoration: "none",
        },
      }}
      data-testid="customer"
    >
      {content.gallery_featured ? (
        <ListItemAvatar
          sx={{
            marginX: 1,
          }}
        >
          <Avatar
            src={`${process.env.REACT_APP_AWS_CLOUDFRONT_URL}${content.gallery_featured.image}`}
          >
            <SellIcon />
          </Avatar>
        </ListItemAvatar>
      ) : (
        <ListItemAvatar
          sx={{
            marginX: 1,
          }}
        >
          <Avatar>
            <SellIcon />
          </Avatar>
        </ListItemAvatar>
      )}

      <ListItemText
        primary={
          <Typography
            color="textPrimary"
            sx={{
              textTransform: "capitalize",
            }}
          >
            {content.parent
              ? `${content.parent.name}/${content.name}`
              : content.name}
          </Typography>
        }
        secondary={
          <Box display="flex" flexDirection="row" gap={5}>
            <Typography
              color="textSecondary"
              sx={{
                textTransform: "capitalize",
              }}
            >
              {content.sku}
            </Typography>
            <Typography
              color="textSecondary"
              sx={{
                textTransform: "capitalize",
                marginLeft: "auto",
              }}
            >
              {content.parent
                ? priceFormat(
                    content.parent.price.price,
                    content.parent.price.currency
                  )
                : priceFormat(content.price.price, content.price.currency)}
            </Typography>
          </Box>
        }
        secondaryTypographyProps={{ component: "div" }}
      />
    </ListItem>
  );
};
